module.exports = __webpack_public_path__ + "static/media/vetsm.54f37331.jpg";